var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subscription)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.planMessage)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }